import React from 'react';
import ReactDom from 'react-dom';

import CheckoutCoupons from '../Components/CheckoutCoupons/index.jsx';
import ErrorBoundary from '../Components/ErrorBoundary/index.jsx';


export default function(document) {
  var elements = document.querySelectorAll('[data-react-component="cs-checkout-coupons"]');

  if (elements && elements.length) {
    var nonce;
    var ajaxUrl;

    if (window.wc_checkout_params) {
      nonce = window.wc_checkout_params.apply_coupon_nonce;
      ajaxUrl = window.wc_checkout_params.wc_ajax_url.replace('%%endpoint%%', 'apply_coupon');
    }

    if (nonce && ajaxUrl) {
      for (var i = 0; i < elements.length; i++) {
        var element = elements[i];

        ReactDom.render(
          <ErrorBoundary>
            <CheckoutCoupons nonce={nonce} ajaxUrl={ajaxUrl} />
          </ErrorBoundary>,
          element
        );
      }
    }
  }
};

